class Session {
  setRedirect = (redirect) => sessionStorage.setItem('redirect', redirect);

  getRedirect = () => sessionStorage.getItem('redirect');

  clearRedirect = () => sessionStorage.removeItem('redirect');

  getEditorCursor = (page) => sessionStorage.getItem(`editor-cursor-${page}`);

  setEditorCursor = (page, values) => sessionStorage.setItem(`editor-cursor-${page}`, values);
}

const session = new Session();

export default session;
